import React from "react";
import logo from "../Assets/Logo/dalmaf-vertical-logo.png";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <>
      <nav className="">
        <div className="container">
          <Link className="navbar-brand" to="/" style={{ display: "flex", justifyContent: "flex-end" }}>
            <img src={logo} alt="Dalmaf Business Associate" className="logo" style={{ float: "right",width:'20%',margin:'20px' }} />
          </Link>
        </div>
      </nav>
      <style>
        {`
          @media (max-width: 768px) {
            .container {
              justify-content: center; /* Center the logo on mobile */
            }
            .logo {
              width: 50% !important; /* Make the logo 50% of the container width */
              margin: 0 auto; /* Center the logo */
            }
          }
        `}
      </style>
    </>
  );
  
};

export default Header;
